import { computed, type ComputedRef, type Ref } from 'vue'
import { flatten } from 'flat'
import { useFilters } from '@/modules/shared/composables/useFilters'

export const normalize = (v: any): string => {
  if (v == null) return ''
  return String(v).toLowerCase().replace(/[$,]/g, '').trim()
}

// Search wrapper modeled on the transactions page's useTransactionFilters: a
// single search filter routed through the shared useFilters infrastructure so
// the SPV/Funds list pages get the same plumbing (Object.values(flatten(item))
// over normalized strings) instead of a bare ref + manual deepSearch.
export function useEntityListFilters(items: ComputedRef<any[]> | Ref<any[]>) {
  const filterConfigs = [
    {
      key: 'search',
      label: 'Search',
      value: '',
      apply: (item: any, val: string) => {
        const q = normalize(val)
        if (!q) return true
        const leaves = Object.values(flatten(item) as Record<string, unknown>)
        return leaves.some((v) => normalize(v).includes(q))
      },
    },
  ]

  const { proxies, apply } = useFilters(filterConfigs)
  const searchFilter = proxies.search as Ref<string>

  const filteredItems = computed(() => apply(items.value))
  const isFilteredEmpty = computed(() => filteredItems.value.length === 0 && items.value.length > 0)
  const hasActiveFilters = computed(() => Boolean(searchFilter.value && searchFilter.value.length > 0))
  const clearAll = () => {
    searchFilter.value = ''
  }

  return { searchFilter, filteredItems, isFilteredEmpty, hasActiveFilters, clearAll }
}
